<template>
  <settings-legacy v-if="useLegacy" @new-view="useNewView" />
  <div v-else-if="ready">
    <settings-mobile v-if="isPhone" />
    <settings-desktop v-else />
    <image-gallery-dialog v-model="galleryOpen" :restaurant-id="restaurantId" @select-image="pickImage" />
  </div>
  <div v-else class="pa-6">
    <page-header icon="mdi-cog" :title="$t('settings')" :subtitle="$t('please_select_restaurant_to_view_data')" />
  </div>
</template>

<script>
import hasSettingsState from "@/components/settings-shell/hasSettingsState";
import SettingsDesktop from "@/components/settings-shell/SettingsDesktop.vue";
import SettingsMobile from "@/components/settings-shell/mobile/SettingsMobile.vue";
import SettingsLegacy from "@/components/settings-shell/SettingsLegacy.vue";
import ImageGalleryDialog from "@/components/restaurants/settings/dialogs/ImageGalleryDialog.vue";

/**
 * Podešavanja restorana (/restaurant/settings): sedam ekrana u tri grupe, traka sa snimanjem i pretragom na računaru,
 * početni ekran sa grupama na telefonu (širina do 600 px). ?ui=stari vraća staru stranicu (tabovi).
 * Stanje (kopija snimljeno / trenutno, razlike, provjere, snimanje) je u hasSettingsState.
 */
export default {
  name: "RestaurantSettingsPage",
  mixins: [hasSettingsState],
  components: { SettingsDesktop, SettingsMobile, SettingsLegacy, ImageGalleryDialog },
};
</script>
